const seasonKeys = {
    all: () => [{ entity: 'season' }],
    allLists: () => [{ ...seasonKeys.all()[0], scope: 'list' }],
    listByShowId: (rawShowId) => [{ ...seasonKeys.allLists()[0], showId: Number(rawShowId) }],
    allDetails: () => [{ ...seasonKeys.all()[0], scope: 'detail' }],
    detailById: (rawSeasonId) => [{ ...seasonKeys.allDetails()[0], seasonId: Number(rawSeasonId) }],
};

export default seasonKeys;
